export default "<re-captcha (resolved)=\"resolved($event)\" siteKey=\"{{recaptchaApiKey}}\"></re-captcha>"